exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main[data-v-0933e1c9]{height:100%;border-top:1px solid #dedede}.list-content[data-v-0933e1c9]{height:100%;overflow:auto}.top-bar[data-v-0933e1c9]{align-items:center;justify-content:space-between;padding:1rem}.title-info[data-v-0933e1c9]{align-items:center;justify-content:space-between;padding:.375rem 1rem 0}.title-info span[data-v-0933e1c9]{font-size:.75rem;color:#464646;line-height:1.125rem}.title-info[data-v-0933e1c9] .van-dropdown-menu__bar{box-shadow:none}.title-info[data-v-0933e1c9] .van-dropdown-menu__title{font-size:.875rem}.title-lable[data-v-0933e1c9]{padding:0 1rem;font-size:x-large}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0933e1c9","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/content/relation/RelationshipList.vue
// module id = 856
// module chunks = 0